
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  --cover-size:40px;
  --cover-fade:30%;
  --cover-color:#fff;
  --shadow-size:10px;
  --shadow-intensity:40%;
}

.tab-group--top .tab-group__tabs{
  margin-bottom:1rem;
}

.tab-group__tabs{
  width:100%;
}

.tab-group__nav{
  background:linear-gradient(
      to right,
      var(--cover-color) var(--cover-fade),
      rgba(255, 255, 255, 0)
    ), linear-gradient(
        to right,
        rgba(255, 255, 255, 0),
        var(--cover-color) calc(100% - var(--cover-fade))
      ) 100% 0, radial-gradient(
        farthest-side at 0 50%,
        rgba(0, 0, 0, var(--shadow-intensity)),
        rgba(0, 0, 0, 0)
      ), radial-gradient(
        farthest-side at 100% 50%,
        rgba(0, 0, 0, var(--shadow-intensity)),
        rgba(0, 0, 0, 0)
      ) 100% 0;
  background-repeat:no-repeat;
  background-size:var(--cover-size) 100%, var(--cover-size) 100%,
    var(--shadow-size) 100%, var(--shadow-size) 100%;
  background-attachment:local, local, scroll, scroll;
  overflow:auto;
  -ms-overflow-style:none;
  scrollbar-width:none;
}
`;